import { render, staticRenderFns } from "./Gg.vue?vue&type=template&id=c41dd04a&scoped=true"
import script from "./Gg.vue?vue&type=script&lang=js"
export * from "./Gg.vue?vue&type=script&lang=js"
import style0 from "./Gg.vue?vue&type=style&index=0&id=c41dd04a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41dd04a",
  null
  
)

export default component.exports